import {
    fetchApiHeaders,
    globalURL
} from "../../helpers/constants";


const getData = () => dispatch => {
    dispatch({
        type: "GET_REFERENCES"
    })

    fetch(globalURL + "/reference/getAll", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST
        }
    })
        .then((result) => result.json())
        .then(async (result) => {
            if (result.success) {
                dispatch({
                    type: "FETCH_REFERENCES",
                    payload: result.data
                })
            } else {
                dispatch({
                    type: "ERROR_REFERENCES",
                    payload: result
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "ERROR_REFERENCES",
                payload: error
            });
        })
}


export {
    getData
}